import './TransitionRoute.scss'
import React from 'react'
import { Route } from 'react-router-dom'

const TransitionRoute = ({ component, ...rest }) => {
  return (
    <Route {...rest} render={(props) => {
      return (
        <div className='TransitionRoute'>
          {React.createElement(component, props)}
        </div>
      )
    }} />
  )
}

TransitionRoute.displayName = 'TransitionRoute'

export default TransitionRoute



// WEBPACK FOOTER //
// ./src/lib/TransitionRoute.js